/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import InputNumber from "../../../../components/hookForms/inputNumber";
import messages from "../../../../utils/messages";
import serviceFaturaSaldoChurn from "../../../../services/serviceFaturaSaldoChurn";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

export interface IDialogProps {
    open: boolean;
    onSuccess: () => void;
    onClose?: any;
    data: {
        open: boolean;
        id: string;
        tarifaCobrada: string;
        saldoNaoPago: string;
        numeroInstalacao: string;
        nomeUsina: string;
    };
}

export default function DialogEdit({ open, onClose, data, onSuccess }: IDialogProps) {
    const [isDisable, setDisable] = useState(false);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            tarifaCobrada: "",
            saldoNaoPago: "",
        },
    });

    useEffect(() => {
        if (data) {
            reset(data);
        }
    }, [data]);

    const onSubmit = (values: any) => {
        setDisable(true);

        const updateValues = {
            ...values,
            faturaSaldoChurnID: data.id,
            tarifaCobrada: values.tarifaCobrada
                ? Number(values.tarifaCobrada.replaceAll(".", "").replaceAll(",", "."))
                : 0,
            saldoNaoPago: values.saldoNaoPago
                ? Number(values.saldoNaoPago.replaceAll(".", "").replaceAll(",", "."))
                : 0,
        };

        serviceFaturaSaldoChurn
            .update(updateValues)
            .then((result) => {
                if (result) {
                    toast.success(messages.updateSucess);
                    onClose(true);
                    onSuccess();
                }
            })
            .catch((err) => {
                toast.error(messages.updateError, err);
            })
            .finally(() => {
                setDisable(false);
            });
    };

    return (
        <>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    Editar Cobrança
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(true);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form>
                    <DialogContent dividers>
                        <Box>
                            <Typography variant="subtitle2">Cobrança ID: {data.id}</Typography>
                            <Typography variant="subtitle2">Instalação: {data.numeroInstalacao}</Typography>
                            <Typography variant="subtitle2">Usina: {data.nomeUsina}</Typography>
                            <Grid container spacing={1}>
                                <Grid item md={4}>
                                    <InputNumber
                                        name="tarifaCobrada"
                                        label="Tarifa (R$)"
                                        control={control}
                                        error={errors}
                                        decimalScale={8}
                                        maxLength={12}
                                    />
                                </Grid>
                                <Grid item md={4}>
                                    <InputNumber
                                        name="saldoNaoPago"
                                        label="Saldo Não Pago (kWh)"
                                        control={control}
                                        error={errors}
                                        decimalScale={2}
                                        maxLength={12}
                                    />
                                </Grid>
                            </Grid>
                        </Box>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            onClick={onClose}
                            color="warning"
                            variant="contained"
                            style={{ width: "159px", height: "44px" }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="button"
                            onClick={handleSubmit(onSubmit)}
                            color="primary"
                            variant="contained"
                            disabled={isDisable}
                            style={{ width: "159px", height: "44px" }}
                        >
                            Salvar
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        </>
    );
}
